import { clientProfileRoutes, staticRoutes } from '@atlas/routing';

import { SIGN_IN_REDIRECT_URL_QUERY_KEY } from 'common/constants';

export const authProtectedRoutes = [
  `/${clientProfileRoutes.achievements}`,
  staticRoutes.tournaments,
];

export const getAuthNavigationLink = (pathname, link) => {
  const searchQueries = new URLSearchParams('');
  searchQueries.set('cmd', 'signin');
  searchQueries.set(SIGN_IN_REDIRECT_URL_QUERY_KEY, link);
  return `${pathname}?${searchQueries}`;
};

export const transformNavigationLink = link => {
  if (link !== `/${clientProfileRoutes.achievements}`) return link;
  return `?cmd=${clientProfileRoutes.achievements}`;
};
